define('views/peoplefinder/Podio.Views.PeopleFinder.Contacts',['require','translate','underscore','lib/jquery/jquery.podioCheckList','lib/backbone/Backbone.PodioView','lib/backbone/Backbone.PodioModel','jst!peoplefinder/_contacts','jst!shared/generic_error','jst!peoplefinder/_blank_slate'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  require('lib/jquery/jquery.podioCheckList');

  var PodioView = require('lib/backbone/Backbone.PodioView');
  var PodioModel = require('lib/backbone/Backbone.PodioModel');

  var jstContacts = require('jst!peoplefinder/_contacts');
  var jstGenericError = require('jst!shared/generic_error');
  var jstBlankSlate = require('jst!peoplefinder/_blank_slate');

  return PodioView.extend({

    initialize: function(options) {

      _.bindAll(this, 'render', 'onContactChecked', 'onContactUnchecked', 'searchContacts', 'onLoadMoreTriggered', 'renderContacts');

      this._super(options);

      this.dataGroup = options.dataGroup;
      this.providerName = options.providerName;

      this.contactsCollection = options.contactsCollection;
      this.contactsReady = options.contactsReady;

      this.contactsReady.done(this.renderContacts);
      this.contactsCollection.bind('error', this.renderError, this);
    },

    displaySpinner: function() {
      this.elm.addClass('loading-overlay-small');
    },

    render: function() {
      if (this.contactsReady.state() === 'pending') {
        this.displaySpinner();
        return;
      }

      // Templating
      this.elm.html(this.getTemplate(jstContacts, {
        translations: {
          placeholder: t('Type a name to search #peoplefinder')
        }
      }));

      this.elmContactsContainer = this.elm.find('.contacts-container');

      // Hide loaders
      this.elm.removeClass('loading-overlay-small');
    },

    renderContacts: function() {
      if (!this.elmContactsContainer) {
        this.render();
      }

      this.elm.removeClass('has-error');

      if (this.contactsCollection.isEmpty()) {
        this.renderEmpty();
        return;
      }

      // Init check list
      this.elm.find('.search input').podioChecklist({
        searchFunc: this.searchContacts,
        searchEnabled: true,
        searchInstantSearchCallback: true,
        searchInEmail: false,
        data: this.contactsCollection.toJSON(),
        checkedItems: this.getCheckedItems(),
        enableScrollLoadMore: true,
        loadMoreFunc: this.onLoadMoreTriggered,
        loadMoreScrollThreshold: 100,
        idKey: 'id',
        preselectAll: false,
        inviteLimit: 500,
        customCheckbox : {
          checked: 'icon-16 icon-16-single-green-tick',
          open: 'icon-16 icon-16-checkbox-open'
        },
        templates: {
          list:  _.template('<ul class="podio-check-list podio-checkbox-list podio-check-list-people"><%-content%></ul>'),
          empty: this.getTemplate.curry(jstBlankSlate)
        },
        classes: {
          resultContainer: '.contacts-container'
        },
        callbacks: {
          onCheck:  this.onContactChecked,
          onUncheck: this.onContactUnchecked
        }
      }).focus();
    },

    renderError: function(collection, responseData) {
      var message = t('An unexpected error has occured. #linked-accounts');

      if (!this.elmContactsContainer) {
        this.render();
      }

      this.elm.addClass('has-error');
      this.elmContactsContainer.html(this.getTemplate(jstGenericError, { message: message }));
    },

    renderEmpty: function() {
      if (!this.elmContactsContainer) {
        this.render();
      }

      this.elmContactsContainer.html(this.getTemplate(jstBlankSlate, { message: this.options.emptyCollectionBlankslate }));
    },

    searchContacts: function(keyword, callback) {
      // Show loader
      this.elmContactsContainer.addClass('loading-overlay-small');

      // Fetch
      this.contactsCollection.offset = 0;
      this.contactsCollection.getContacts(keyword).done(_.bind(function(responseData) {

        // Hide loader
        this.elmContactsContainer.removeClass('loading-overlay-small');

        // Callback time
        callback(responseData.data.object);

      }, this));
    },

    getCheckedItems: function() {
      var self = this;
      var checkedItemsState = {};
      var values = _.flatten(this.model.attributes);

      var checkedItems = _.filter(values, function(item) {
        return item.ref_type === self.dataGroup;
      });

      // Map to checklist checked-state
      _.each(checkedItems, function(item) {
        checkedItemsState[item.id] = item;
      });

      return checkedItemsState;
    },

    onContactChecked: function(userId, user) {
      this.trigger('peopleFinderContacts:contactChecked', new PodioModel(user));
    },

    onContactUnchecked: function(userId, user) {
      this.trigger('peopleFinderContacts:contactUnchecked', new PodioModel(user));
    },

    onLoadMoreTriggered: function(callback) {

      this.contactsCollection.getContacts().done(function(responseData) {
        callback(responseData.data.object);
      });

    }

  });

});

